import { useCallback } from "react";
import { useAppDispatch, useRootState } from "./index";
import {
  trunkAddContentMemo,
  trunkGetContentDetail,
  trunkGetContentDownload,
  trunkContentsDownload,
  trunkGetContentFavorite,
  trunkGetContentList,
  trunkGetContentThumbnail,
  trunkGetDocUsingByWebIncludeToken,
  trunkGetReadRequestContentList,
  trunkDocDelete,
  trunkDocDeleteNow,
  trunkDocRestore,
  trunkDocDecryptDownload,
  trunkDocUploadUidCreate,
  trunkDocUploadFile,
  trunkDocChangeName,
  trunkChangeDocMaster,
  trunkGetMemos,
  trunkDocReqRead,
  trunkDeleteReadRequest,
  trunkRequestReadList,
  trunkContentCheckout,
  trunkContentUndoCheckout,
  trunkCreateFolder,
  trunkDeleteFolder,
  trunkUpdateFolder,
  trunkDocDeliveryUid,
  trunkDocUploadFileComplete,
  trunkDocUploadFileCompleteDelivery,
  trunkSetAddUploadProgressFiles,
  trunkSetUpdateUploadProgressFiles,
  trunkRemoveFileFromUidList,
  trunkGetDocSyncInfo,
  trunkforceWebCheckin,
  trunkWebCheckin,
  trunkCancelChatWithAI,
  trunkCheckAIDocPermission,
  trunkCheckAnswerWithAI,
  trunkCloseChatWithAI,
  trunkDoChatWithAI,
  trunkChangeDragItem,
  trunkFolderInfo,
  trunkDocUploadRevisionFile,
  trunkUpdateFileFolder,
  trunkGetUploadDocsProgress,
  trunkGetDocTimeline,
  trunkDocUpdateUid,
  trunketDocUserViewCount,
  trunkRemoveUid,
  trunkRecallGetContentList,
} from "../store/document";
import {
  AddMemoReq,
  DocAIChatRequest,
  DocDownloadRequestDTO,
  DocInfo,
  DocumentListReq,
  FileFolderReq,
  FwocFilesLicensesRequestDTO,
  MemoDTO,
  ReadReqeustDto,
  ReadRequestDto,
  UploadCompleteRequestDTO,
  UploadFile,
} from "../../types/files";
import { FileWithPath } from "react-dropzone/.";
import { DeliveryUIDRequestRespondDTO } from "../../types/adminSetting";

// # hooks
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDocumentStore = () => {
  const documentState = useRootState((state) => state.documentStore);

  const dispatch = useAppDispatch();

  const boundGetContentDetail = useCallback(
    (req: { workgroupId: string; syncId: string; type?: "aside" }) =>
      dispatch(trunkGetContentDetail(req)).then(),
    [dispatch]
  );
  const boundGetContentThumbnail = useCallback(
    (req: { syncId: string; revisionNo: number }) =>
      dispatch(trunkGetContentThumbnail(req)).then(),
    [dispatch]
  );
  const boundGetContentList = useCallback(
    (req: DocumentListReq) => dispatch(trunkGetContentList(req)).then(),
    [dispatch]
  );
  const boundGetReadRequestContentList = useCallback(
    (req: ReadRequestDto) =>
      dispatch(trunkGetReadRequestContentList(req)).then(),
    [dispatch]
  );
  const boundGetContentFavorite = useCallback(
    (req: { flag: boolean; syncIds: string[]; page?: string }) =>
      dispatch(trunkGetContentFavorite(req)).then(),
    [dispatch]
  );
  const boundAddContentMemo = useCallback(
    (req: AddMemoReq) => dispatch(trunkAddContentMemo(req)).then(),
    [dispatch]
  );
  const boundGetDocUsingByWebIncludeToken = useCallback(
    (req: FwocFilesLicensesRequestDTO) =>
      dispatch(trunkGetDocUsingByWebIncludeToken(req)).then(),
    [dispatch]
  );
  const boundGetContentDownload = useCallback(
    (reqDto: DocDownloadRequestDTO) =>
      dispatch(trunkGetContentDownload(reqDto)).then(),
    [dispatch]
  );
  const boundDocDecrpytDownload = useCallback(
    (reqDto: DocDownloadRequestDTO) =>
      dispatch(trunkDocDecryptDownload(reqDto)).then(),
    [dispatch]
  );
  const boundDocChangeName = useCallback(
    (req: { contentName: string; syncId: string }) =>
      dispatch(trunkDocChangeName(req)).then(),
    [dispatch]
  );
  const boundChangeDocMaster = useCallback(
    ({
      syncId,
      fromUserId,
      toUserId,
      rev,
    }: {
      syncId: string | string[];
      fromUserId: string;
      toUserId: string;
      rev: number;
    }) =>
      dispatch(
        trunkChangeDocMaster({ syncId, fromUserId, toUserId, rev })
      ).then(),
    [dispatch]
  );
  const boundContentsDownload = useCallback(
    ({ syncIds, startDownload }: { syncIds: string[]; startDownload: any }) =>
      dispatch(trunkContentsDownload({ syncIds, startDownload })).then(),
    [dispatch]
  );
  const boundDocDelete = useCallback(
    (syncIds: string[]) => dispatch(trunkDocDelete(syncIds)).then(),
    [dispatch]
  );
  const boundDocDeleteNow = useCallback(
    (syncIds: string[]) => dispatch(trunkDocDeleteNow(syncIds)).then(),
    [dispatch]
  );
  const boundDocRestore = useCallback(
    (syncIds: string[]) => dispatch(trunkDocRestore(syncIds)).then(),
    [dispatch]
  );
  const boundDocUploadUidCreate = useCallback(
    () => dispatch(trunkDocUploadUidCreate()).then(),
    [dispatch]
  );
  const boundDocUpdateUid = useCallback(
    (uid: string) => dispatch(trunkDocUpdateUid(uid)).then(),
    [dispatch]
  );
  const boundDocUploadFile = useCallback(
    (uid: string, file: FileWithPath, setProgressPercent?: any) =>
      dispatch(trunkDocUploadFile({ uid, file, setProgressPercent })).then(),
    [dispatch]
  );
  const boundGetMemos = useCallback(
    (reqDto: MemoDTO) => dispatch(trunkGetMemos(reqDto)).then(),
    [dispatch]
  );
  const boundDocRequestRead = useCallback(
    (req: ReadReqeustDto) => dispatch(trunkDocReqRead(req)).then(),
    [dispatch]
  );
  const boundGetReadRequestList = useCallback(
    (syncId: string) => dispatch(trunkRequestReadList({ syncId })).then(),
    [dispatch]
  );
  const boundDeleteRequestRead = useCallback(
    (syncId: string, requestId: string) =>
      dispatch(trunkDeleteReadRequest({ syncId, requestId })).then(),
    [dispatch]
  );
  const boundContentCheckout = useCallback(
    (reqDto: { syncId: string; revisionNo: number; workgroupId: string }) =>
      dispatch(trunkContentCheckout(reqDto)).then(),
    [dispatch]
  );
  const boundContentUndoCheckout = useCallback(
    (reqDto: { syncId: string; revisionNo: number; workgroupId: string }) =>
      dispatch(trunkContentUndoCheckout(reqDto)).then(),
    [dispatch]
  );
  const boundcreateFolder = useCallback(
    (folder: FileFolderReq) => dispatch(trunkCreateFolder(folder)).then(),
    [dispatch]
  );
  const boundUpdateFolder = useCallback(
    (folder: FileFolderReq) => dispatch(trunkUpdateFolder(folder)).then(),
    [dispatch]
  );
  const boundDeleteFolder = useCallback(
    (folder: FileFolderReq) => dispatch(trunkDeleteFolder(folder)).then(),
    [dispatch]
  );
  const boundDocDeliveryUid = useCallback(
    (req: DeliveryUIDRequestRespondDTO) =>
      dispatch(trunkDocDeliveryUid(req)).then(),
    [dispatch]
  );
  const boundDocUploadFileComplete = useCallback(
    (uid: string, req: UploadCompleteRequestDTO, isLoading?: boolean) =>
      dispatch(trunkDocUploadFileComplete({ uid, req, isLoading })).then(),
    [dispatch]
  );
  const boundForceWebCheckin = useCallback(
    (syncId: string) => dispatch(trunkforceWebCheckin({ syncId })).then(),
    [dispatch]
  );
  const boundDocUploadFileCompleteDelivery = useCallback(
    (uid: string, req: UploadCompleteRequestDTO) =>
      dispatch(trunkDocUploadFileCompleteDelivery({ uid, req })).then(),
    [dispatch]
  );
  const boundSetAddUploadProgressFiles = useCallback(
    (uploadFile: UploadFile) =>
      dispatch(trunkSetAddUploadProgressFiles(uploadFile)).then(),
    [dispatch]
  );
  const boundSetUpdateUploadProgressFiles = useCallback(
    (uploadFile: UploadFile) =>
      dispatch(trunkSetUpdateUploadProgressFiles(uploadFile)).then(),
    [dispatch]
  );
  const boundRemoveFileFromUid = useCallback(
    (uid: string, uuid: string, fileId: string) =>
      dispatch(trunkRemoveFileFromUidList({ uid, uuid, fileId })).then(),
    [dispatch]
  );
  const boundGetSyncInfo = useCallback(
    (reqDto: { workgroupId: string; syncId: string }) =>
      dispatch(trunkGetDocSyncInfo(reqDto)).then(),
    [dispatch]
  );
  const boundContentWebCheckin = useCallback(
    (workgroupId: string, syncId: string, revisionNo: number) =>
      dispatch(trunkWebCheckin({ workgroupId, syncId, revisionNo })).then(),
    [dispatch]
  );
  const boundDoChatWithAI = useCallback(
    (request: DocAIChatRequest) => dispatch(trunkDoChatWithAI(request)).then(),
    [dispatch]
  );
  const boundCancelAIDocChat = useCallback(
    (request: DocAIChatRequest) =>
      dispatch(trunkCancelChatWithAI(request)).then(),
    [dispatch]
  );
  const boundCheckAIDocPermission = useCallback(
    (syncIds: string[]) => dispatch(trunkCheckAIDocPermission(syncIds)).then(),
    [dispatch]
  );
  const boundCloseAIDocChat = useCallback(
    (convoId: string) => dispatch(trunkCloseChatWithAI(convoId)).then(),
    [dispatch]
  );
  const boundCheckAnswerWithAI = useCallback(
    (request: DocAIChatRequest) =>
      dispatch(trunkCheckAnswerWithAI(request)).then(),
    [dispatch]
  );
  const boundChangeDragItem = useCallback(
    (request: DocInfo[], isDirect?: boolean) =>
      dispatch(trunkChangeDragItem({ request, isDirect })).then(),
    [dispatch]
  );
  const boundFolderInfo = useCallback(
    (folderId: string) => dispatch(trunkFolderInfo(folderId)).then(),
    [dispatch]
  );
  const boundUpdateFileFolder = useCallback(
    (folder: FileFolderReq) => dispatch(trunkUpdateFileFolder(folder)).then(),
    [dispatch]
  );
  const boundDocUploadRevisionFile = useCallback(
    (
      uid: string,
      file: FileWithPath,
      syncId: string,
      setProgressPercent: any
    ) =>
      dispatch(
        trunkDocUploadRevisionFile({ uid, file, syncId, setProgressPercent })
      ).then(),
    [dispatch]
  );
  const boundGetUploadDocsProgress = useCallback(
    (uid: string) => dispatch(trunkGetUploadDocsProgress(uid)).then(),
    [dispatch]
  );
  const boundGetDocTimeline = useCallback(
    (req: { workgroupId: string; syncId: string }) =>
      dispatch(trunkGetDocTimeline(req)).then(),
    [dispatch]
  );
  const boundDocUserViewCount = useCallback(
    (req: { syncId: string; workgroupId: string }) =>
      dispatch(trunketDocUserViewCount(req)).then(),
    [dispatch]
  );
  const boundRemoveUid = useCallback(
    () => dispatch(trunkRemoveUid()).then(),
    [dispatch]
  );
  const boundRecallGetContentList = useCallback(
    () => dispatch(trunkRecallGetContentList()).then(),
    [dispatch]
  );
  return {
    documentState,
    getContentDetail: boundGetContentDetail,
    changeDocMaster: boundChangeDocMaster,
    getContentThumbnail: boundGetContentThumbnail,
    getContentDownload: boundGetContentDownload,
    getContentsDownload: boundContentsDownload,
    getDocDecryptDownload: boundDocDecrpytDownload,
    getContentList: boundGetContentList,
    getReadRequestContentList: boundGetReadRequestContentList,
    getContentFavorite: boundGetContentFavorite,
    addContentMemo: boundAddContentMemo,
    getDocUsingByWebIncludeToken: boundGetDocUsingByWebIncludeToken,
    getDocDelete: boundDocDelete,
    getDocDeleteNow: boundDocDeleteNow,
    getDocRestore: boundDocRestore,
    getDocUploadUidCreate: boundDocUploadUidCreate,
    changeDocUploadUidCreate: boundDocUpdateUid,
    doDocUploadFile: boundDocUploadFile,
    setChangeDocName: boundDocChangeName,
    getContentMemo: boundGetMemos,
    doRequestRead: boundDocRequestRead,
    getReadRequestList: boundGetReadRequestList,
    deleteReadRequest: boundDeleteRequestRead,
    getContentCheckout: boundContentCheckout,
    getContentUndoCheckout: boundContentUndoCheckout,
    createFolder: boundcreateFolder,
    updateFolder: boundUpdateFolder,
    deleteFolder: boundDeleteFolder,
    getDocDeliveryUid: boundDocDeliveryUid,
    doDocUploadFileComplete: boundDocUploadFileComplete,
    doDocUploadFileCompleteDelivery: boundDocUploadFileCompleteDelivery,
    setAddUploadProgressFiles: boundSetAddUploadProgressFiles,
    setUpdateUploadProgressFiles: boundSetUpdateUploadProgressFiles,
    removeFileFromUid: boundRemoveFileFromUid,
    getSyncInfo: boundGetSyncInfo,
    removeUid: boundRemoveUid,
    completeCheckinByWeb: boundContentWebCheckin,
    forceCheckinByWeb: boundForceWebCheckin,
    doAIDocChat: boundDoChatWithAI,
    cancelAIDocChat: boundCancelAIDocChat,
    checkAIDocPermission: boundCheckAIDocPermission,
    closeAIDocChat: boundCloseAIDocChat,
    checkAnswerAIDocChat: boundCheckAnswerWithAI,
    changeDragItem: boundChangeDragItem,
    getFolderInfo: boundFolderInfo,
    updateFileIntoOtherFolder: boundUpdateFileFolder,
    doDocUploadRevisionFile: boundDocUploadRevisionFile,
    getUploadDocsProgress: boundGetUploadDocsProgress,
    getDocTimeline: boundGetDocTimeline,
    getDocUserViewCount: boundDocUserViewCount,
    recallGetContentList: boundRecallGetContentList,
  };
};

export default useDocumentStore;
